import { LOCAL_STORAGE_REDIRECT_URI_KEY } from '@/constants'

export const determineRedirectUri = (defaultRedirectUri: string): string => {
  return localStorage.getItem(LOCAL_STORAGE_REDIRECT_URI_KEY) || defaultRedirectUri
}
